import { FC, ReactElement, useEffect, useState } from 'react'

import {
  ChartContainer,
  Container,
  ContainerCard,
  HeaderContainer,
  IconContainer,
  PercentageContainer,
  PercentageText,
  TitleContainer,
  TitleContainerMobile,
  TitleText,
  TitleTextMobile,
  TotalText,
} from './style'

import { PRIMARY_BLUE_01 } from 'bd-web-components/src/utils/dash-colors'
import PieChart from './chart/indext'
import { Icon } from 'bd-web-components'
import { useGetProposalPercent } from '../../../hooks/proposal-percent'
import Loader from '../../../components/Loader'

export interface DashboardInterestMeterCardProps {
  title: string
}

const ProposalPercent: FC<DashboardInterestMeterCardProps> = ({
  title,
}: DashboardInterestMeterCardProps): ReactElement => {
  const [percent, setPercent] = useState<any>(null)
  const { proposalPercent, proposalPercentLoading, proposalPercentError } =
    useGetProposalPercent()

  useEffect(() => {
    if (proposalPercent !== undefined) {
      setPercent(proposalPercent)
    }
  }, [proposalPercent, proposalPercentLoading, proposalPercentError])

  return (
    <Container>
      {proposalPercentLoading && (
        <div
          style={{
            height: '600px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Loader />
        </div>
      )}
      {proposalPercentError && !proposalPercentLoading && (
        <div
          style={{
            height: '600px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          Um erro aconteceu, tente novamente!
        </div>
      )}
      {percent !== null && (
        <>
          <TitleContainerMobile>
            <TitleTextMobile>{title}</TitleTextMobile>
          </TitleContainerMobile>

          <ContainerCard>
            <HeaderContainer>
              <TitleContainer>
                <TitleText>{title}</TitleText>
                <IconContainer>
                  <Icon
                    fill={PRIMARY_BLUE_01}
                    classes="question-circle-help-center"
                    iconName="dashboardQuestion"
                    width={17}
                    height={17}
                  />
                </IconContainer>
              </TitleContainer>
            </HeaderContainer>

            {percent.web.render && (
              <>
                <PercentageContainer>
                  <TotalText>Origem WEB:</TotalText>
                  <PercentageText>
                    {Number(percent.web.withoutFees).toFixed(2)}%
                  </PercentageText>
                </PercentageContainer>
                <ChartContainer>
                  <PieChart
                    comTaxas={percent.web.withFees}
                    semTaxas={percent.web.withoutFees}
                  />
                </ChartContainer>
              </>
            )}
            <br />
            {percent.tef.render && (
              <>
                <PercentageContainer>
                  <TotalText>Origem Tef:</TotalText>
                  <PercentageText>
                    {Number(percent.tef.withoutFees).toFixed(2)}%
                  </PercentageText>
                </PercentageContainer>

                <ChartContainer>
                  <PieChart
                    comTaxas={percent.tef.withFees}
                    semTaxas={percent.tef.withoutFees}
                  />
                </ChartContainer>
              </>
            )}
          </ContainerCard>
        </>
      )}
    </Container>
  )
}

export default ProposalPercent
